import { render, staticRenderFns } from "./DialogValidationAlumno.vue?vue&type=template&id=449735ab"
import script from "./DialogValidationAlumno.vue?vue&type=script&lang=js"
export * from "./DialogValidationAlumno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports